export function useBoothModal() {
  const route = useRoute()
  const router = useRouter()

  const index = computed<number | undefined>({
    get: () => {
      return route.hash ? Number(route.hash.slice(1)) - 1 : undefined
    },
    set: (value) => {
      router.push({ 
        query: route.query, 
        hash: value !== undefined ? `#${value + 1}` : undefined
      })
    },
  })

  const model = computed<boolean>({
    get: () => {
      return index.value !== undefined
    },
    set: (value) => {
      if (!value) {
        index.value = undefined
      }
    },
  })

  return reactive({ index, model })
}